/**
 * JWT token storage for student portal accounts — separate key from the staff
 * token so staff and student sessions can coexist in the same browser tab.
 */

const STUDENT_TOKEN_KEY = 'egs:student-portal:access';

export class StudentTokenStorage {
  static get(): string | null {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(STUDENT_TOKEN_KEY);
  }

  static set(token: string): void {
    sessionStorage.setItem(STUDENT_TOKEN_KEY, token);
  }

  static clear(): void {
    sessionStorage.removeItem(STUDENT_TOKEN_KEY);
  }
}
